import React from "react";
import "./style.css";
import logo from "../../assets/images/logo.png";
import { Link } from "react-router-dom";
import PhoneIcon from "@material-ui/icons/Phone";
import FacebookIcon from "@material-ui/icons/Facebook";
import TwitterIcon from "@material-ui/icons/Twitter";
import InstagramIcon from "@material-ui/icons/Instagram";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import EmailIcon from "@material-ui/icons/Email";
import LocationOnIcon from "@material-ui/icons/LocationOn";

export const Footer = () => {
  return (
    <div className="container footer-section bg-blue">
      <div className="divider"></div>
      <div className="flex ai-c">
        <img className="footer-logo-img" src={logo} alt="CSIT Mantra" />
        <Link to="/" className="ml-2 link footer-logo-text text-white fw-500">
          CSIT Mantra
        </Link>
      </div>
      <div className="footer-items grid grid-3 gap-3 py-1 mt-2">
        <div className="contact">
          <div className="contact-details">
            <h3 className="fw-500 fit-content text-white footer-title">
              Contact Details
            </h3>
            <div className="flex mt-4 ai-c footer-icons">
              <div className="circle-icon-container">
                <PhoneIcon />
              </div>
              <span className="ml-2 text-lato text-white">+977 9862012458</span>
            </div>
            <div className="flex mt-2 ai-c footer-icons">
              <div className="circle-icon-container">
                <EmailIcon />
              </div>
              <span className="ml-2 text-white">@csitmantra.com</span>
            </div>
            <div className="flex mt-2 ai-c footer-icons">
              <div className="circle-icon-container">
                <LocationOnIcon />
              </div>
              <span className="ml-2 text-white">Kathmandu, Nepal</span>
            </div>
          </div>
          <div className="my-2 flex fd-col">
            <h3 className="fw-500 text-white footer-title fit-content">
              Social Link
            </h3>
            <div className="social-link-container flex mt-4">
              <Link to="" className="facebook link circle-icon-container">
                <FacebookIcon />
              </Link>
              <Link to="" className="twitter ml-2 link circle-icon-container">
                <TwitterIcon />
              </Link>
              <Link to="" className="linkedin ml-2 link circle-icon-container">
                <LinkedInIcon />
              </Link>
              <Link to="" className="instagram ml-2 link circle-icon-container">
                <InstagramIcon />
              </Link>
            </div>
          </div>
        </div>
        <div className="flex fd-col">
          <h3 className="text-white fw-500 fit-content footer-title">
            Quick Links
          </h3>
          <div className="mt-4">
            <Link
              to="#"
              className="text-white link text-capitalize hover-black"
            >
              Declaimer
            </Link>
          </div>
          <div className="mt-1">
            <Link
              to="#"
              className="text-white  link text-capitalize hover-black"
            >
              Privacy Policy
            </Link>
          </div>
          <div className="mt-3">
            <h3 className="text-white fw-500 fit-content footer-title">
              Latest Event
            </h3>
            <p className="mt-4 text-white">No any event yet 😪</p>
          </div>
        </div>
        <div className="flex fd-col">
          <h3 className="text-white fit-content fw-500 text-capitalize footer-title">
            Facebook Page
          </h3>
          <iframe
            src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fcsitmantra%2F&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
            height="300"
            style={{
              margin: "1.6rem 0",
            }}
            scrolling="no"
            frameBorder="0"
            allowFullScreen="true"
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          ></iframe>
        </div>
      </div>
      <div className="divider"></div>
      <div className="copyright">
        <p className="text-white text-center">
          Copyright &copy; CSIT Mantra{" "}
          <span className="text-lato">{new Date().getFullYear()}. </span>
          All rights reserved.
        </p>
      </div>
      <div className="divider"></div>
    </div>
  );
};
